import { Injectable, inject } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { Observable } from 'rxjs';
import { filter, map, switchMap } from 'rxjs';
import { DocumentActionState, DocumentActionStore } from './document-action.store';

@Injectable({
  providedIn: 'root',
})
export class DocumentActionQuery extends QueryEntity<DocumentActionState> {
  protected store: DocumentActionStore;

  constructor() {
    const store = inject(DocumentActionStore);

    super(store);

    this.store = store;
  }

  public hasSignedDocument(documentId: string): Observable<boolean> {
    return this.selectLoading().pipe(
      filter((isLoading) => !isLoading),
      switchMap(() =>
        this.selectAll({
          filterBy: (signature) => signature.documentId === documentId,
        })
      ),
      map((signatures) => !!signatures.length)
    );
  }
}
